import React from 'react';
import { boldPrices, parseTerms } from '../../common/common';
import { useCartData } from '../../hooks/order';

// The "Internet" terms/commitment copy (contract length, Early Termination Fee, install fee
// disclosures, etc.) is API-driven off internetPlan.termsOfSrvc(Esp) - this is the same
// content TermsInfo.js's Terms & Conditions step has always rendered. Pulled out into its own
// component so PaymentDetail.js's single-page-checkout layout can show the identical
// legacy-sourced content instead of a hardcoded copy of the Figma placeholder text.
const InternetTermsSection = () => {
  const { isInternetAdded, internetPlan, spanishLanguagePref, isSelfInstall } = useCartData();

  if (!isInternetAdded) {return null;}

  // ELNKWEB-2948: CSI self install has its own terms (self-install kit, Processing & Handling
  // fee). isSelfInstall already requires a CSI-eligible plan; fall back to the professional
  // terms if a plan comes back without the csi fields, so the section is never empty.
  const englishTerms = (isSelfInstall && internetPlan?.csiTermsOfSrvc) || internetPlan?.termsOfSrvc;
  const spanishTerms = (isSelfInstall && internetPlan?.csiTermsOfSrvcEsp) || internetPlan?.termsOfSrvcEsp;
  const termsArr = englishTerms?.split('.  ') || [];
  const bulletPoints = parseTerms(spanishTerms);

  return (
    <div className="terms-info-section m-bottom-0-5">
      <h4 style={{ fontWeight: 'bold' }}>Internet</h4>
      <ul className="terms-info-list ">
        {!spanishLanguagePref
          ? termsArr?.map((i) => <li key={i} dangerouslySetInnerHTML={{ __html: boldPrices(i.endsWith('.') ? i : i + '.') }} />)
          : bulletPoints?.map((point, index) => (
            <li key={index} dangerouslySetInnerHTML={{ __html: boldPrices(point + '.') }} />
          ))}
      </ul>
    </div>
  );
};

export default InternetTermsSection;
